import { PostAlertsResponse, PostAlertsV2Request } from '@api/api/event-alerts';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useInfiniteQuery } from '@tanstack/react-query';
import { postAlertsV2 } from '@terminal/services/alerts/event-alerts-service';
import { QUERY_KEY_EVENT_ALERTS } from './event-alerts-query-keys';

export const getEventAlertsInfiniteQueryOptions = (isUnread: boolean) => ({
  initialPageParam: null as string | null,
  getNextPageParam: (lastPage: PostAlertsResponse): string | null =>
    lastPage?.next_cursor ?? null,
  staleTime: isUnread ? 0 : getTimeTillEndOfDayMs(),
});

export const usePostAlertsV2 = (body: PostAlertsV2Request, enabled = true) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_EVENT_ALERTS, 'v2', body],
    queryFn: ({ pageParam }) =>
      postAlertsV2({ ...body, next: pageParam ?? undefined }),
    enabled,
    ...getEventAlertsInfiniteQueryOptions(body.read === false),
  });
